// DialogWindows.js
import DialogWrapper from "../SwmmReact_Staging/DialogWrapper"

/**
 * This component is used to display many of the draggable/resisable dialog boxes.
 * 
 * @param {Array<Object>} dialogParams Array containing many different settings for a Dialog Window
 * @param {Array<Object>} dialogPositions Array containing updatable positions, sizes, and z-indexes of dialog windows.
 * @param {Object<Object>} dialogStates Object stating whether a dialog window is open or closed.
 * @param {function} handleZIndexAssign updates the zIndex of a dialog when the dialog is clicked on.
 * @returns {JSX} component displaying the model dialogs for the application.
 */
const DialogWindows = ({ dialogParams, dialogPositions, dialogStates, handleZIndexAssign }) => {
  return (
    <>   
    {
      dialogParams.map((v, i) => (
        dialogStates[v.name].open === true &&
        <div key={v.name + i}>
        {
          <DialogWrapper 
            handleClose={()=>dialogStates[v.name].setOpen(false)}
            position={dialogPositions[v.name].position} 
            setPosition={dialogPositions[v.name].setPosition}
            handleZIndexAssign={handleZIndexAssign} 
            minHeight={v.minHeight} >
              <v.component {...v.props} />
          </DialogWrapper>
        }
        </div>
      ))
    }  
    </>
  )
}


export default DialogWindows